// extracted by mini-css-extract-plugin
export default {"data":"text-area-data-UTlxao","containerError":"text-area-containerError-qYE0vA","error":"text-area-error-LO2qkr","errorMessage":"text-area-errorMessage-xiDJ3W"};